<template>
<div v-if="data">
  <div class="container py-4">

    <!-- HEADER -->
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 gap-2">
      <h2 class="fw-bold text-primary mb-2 mb-md-0">
        <i class="bi bi-hospital"></i> Détails de l’hospitalisation
      </h2>

      <div class="d-flex flex-wrap gap-2">
       <div v-if="$store.getters.hasPermission('HOSP_IMPRESSION')" class="dropdown">
  <button class="btn btn-outline-primary dropdown-toggle" data-bs-toggle="dropdown">
    <i class="bi bi-printer"></i> Imprimer
  </button>

  <ul class="dropdown-menu">
    <li>
      <a class="dropdown-item" @click="imprimerHospitalisationA4(data)">
        Format A4
      </a>
    </li>
    <li>
      <a class="dropdown-item" @click="imprimerHospitalisationTicketEpson(data)">
        Ticket Epson
      </a>
    </li>
  </ul>
</div>

        <button
          v-if="(data && data.resteAPayer > 0) && data.statut !== 'Clôturée' && $store.getters.hasPermission('HOSP_PAIEMENT')"
          class="btn btn-warning"
          @click="ouvrirPaiement(data)"
        >
          <i class="bi bi-cash-stack"></i> Paiement
        </button>

        <button
          v-if="data && data.statut !== 'Clôturée'  && $store.getters.hasPermission('HOSP_CLOTURE')"
          class="btn btn-success"
          @click="showModal = true"
        >
          <i class="bi bi-check2-circle"></i> Clôturer
        </button>

        <button
          v-if="data && data.statut === 'Clôturée' && $store.getters.hasPermission('HOSP_CLOTURE_ANNULE')"
          class="btn btn-danger"
          @click="annulerCloture"
        >
          <i class="bi bi-arrow-counterclockwise"></i> Annuler la clôture
        </button>

        <button class="btn btn-secondary" @click="$router.back()">
          <i class="bi bi-arrow-left"></i> Retour
        </button>
      </div>
    </div>

    <!-- LOADING -->
    <div v-if="loading" class="text-center my-5">
      <div class="spinner-border text-primary" style="width:50px;height:50px"></div>
      <p class="mt-2">Chargement en cours...</p>
    </div>

    <!-- CONTENU -->
    <div v-else class="card shadow-sm p-4 content-print">

      <!-- MODAL CLOTURE -->
      <div v-if="showModal" class="modal-backdrop-custom">
        <div class="modal-custom">
          <h5 class="fw-bold">Clôturer l’hospitalisation</h5>

          <label class="mt-3">Date de sortie réelle :</label>
          <input type="date" v-model="dateSortieReelle" class="form-control" />

          <div class="mt-3 d-flex justify-content-end gap-2 flex-wrap">
            <button class="btn btn-secondary" @click="showModal = false">Annuler</button>
            <button class="btn btn-success" @click="cloturerHospitalisation">Valider</button>
          </div>
        </div>
      </div>

      <!-- PATIENT -->
      <h4 class="section-title"><i class="bi bi-person"></i> Informations Patient</h4>
      <div class="row mb-3">
        <div class="col-12 col-sm-6 col-md-4"><strong>Nom :</strong> {{ data.patient?.nom }} {{ data.patient?.prenom }}</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Dossier :</strong> {{ data.patient?.numeroDossier }}</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Téléphone :</strong> {{ data.patient?.telephone }}</div>
      </div>

      <hr />

      <!-- HOSPITALISATION -->
      <h4 class="section-title"><i class="bi bi-file-medical"></i> Hospitalisation</h4>
      <div class="row mb-3">
        <div class="col-12 col-sm-6 col-md-4"><strong>Date entrée :</strong> {{ formatDate(data.dateEntree) }}</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Sortie prévue :</strong> {{ formatDate(data.dateSortiePrevue) }}</div>
        <div class="col-12 col-sm-6 col-md-4">
          <strong>Sortie réelle :</strong>
          <span class="text-danger" v-if="!data.dateSortieReelle">En cours</span>
          <span v-else>{{ formatDate(data.dateSortieReelle) }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Statut :</strong> {{ data.statut }}</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Num Hospitalisation :</strong> {{ data.numHospitalisation }}</div>
      </div>

      <hr />

      <!-- CHAMBRE -->
      <h4 class="section-title"><i class="bi bi-door-open"></i> Chambre & Lit</h4>
      <div class="row mb-3">
        <div class="col-12 col-sm-6 col-md-4"><strong>Chambre :</strong> {{ data.chambre.numero }}</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Type :</strong> {{ data.chambre.type?.nom }} — {{ data.chambre.type.tarifParJour }} F/jour</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Lit :</strong> {{ data.lit.numero }}</div>
      </div>

      <hr />

      <!-- PAIEMENTS -->
      <h4 class="section-title"><i class="bi bi-cash-stack"></i> Paiements</h4>
      <div class="row g-2">
        <div class="col-12 col-sm-6 col-md-4"><strong>Montant calculé :</strong> {{ formatPrice(data.montantCalcule.montant) }} F</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Total payé :</strong> {{ formatPrice(data.totalPaye) }} F</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Reste à payer :</strong> {{ formatPrice(data.resteAPayer) }} F</div>
        <div class="col-12 col-sm-6 col-md-4 text-success" v-if="data.remboursement > 0"><strong>Remboursement :</strong> {{ formatPrice(data.remboursement) }} F Si sortie aujourd'hui</div>
        <div class="col-12 col-sm-6 col-md-4 text-success" v-if="data.totalPaye - montant > 0"><strong>Remboursement :</strong> {{ formatPrice(data.totalPaye - formatPrice(montantReelCalcule)) }} F</div>
      </div>

      <!-- HISTORIQUE DES TRANSACTIONS -->
      <div class="card mt-4">
        <div class="card-header fw-bold bg-light">Historique des paiements</div>

        <div class="card-body p-0 table-responsive">
          <table class="table table-bordered mb-0">
            <thead class="table-primary">
              <tr>
                <th>Date</th>
                <th>Montant de base</th>
                <th>Montant Payé</th>
                <th>Assurance</th>
                <th>Part Assurance</th>
                <th>Paiement Patient</th>
                <th>Taux</th>
                <th>Type</th>
                <th>Enregistrer par</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!data.paiements || data.paiements.length === 0">
                <td colspan="9" class="text-center text-muted">Aucun paiement enregistré</td>
              </tr>
              <tr v-for="(p, index) in data.paiements" :key="index">
                <td>{{ formatDateTime(p.datePaiement) }}</td>
                <td>{{ formatPrice(p.montantBase) }}</td>
                <td class="fw-bold">{{ formatPrice(p.montant) }} F</td>
                <td>{{ p.assurance ? p.assurance.nom : 'Aucune' }}</td>
                <td class="text-success">{{ formatPrice(p.partAssurance) }} F</td>
                <td class="text-primary">{{ formatPrice(p.partPatient) }} F</td>
                <td>{{ p.assurance ? p.assurance.tauxCouverture + '%' : '—' }}</td>
                <td><span class="badge bg-info">{{ p.type }}</span></td>
                <td>{{ p.createdBy?.nom }} {{ p.createdBy?.prenom }}</td>
                <td>
  <div class="btn-group btn-group-sm">
    <button 
      class="btn btn-outline-success"
      @click="imprimerPaiementHospitalisationA4(p, data)">
      A4
    </button>

    <button 
      class="btn btn-outline-dark"
      @click="imprimerPaiementHospitalisationTicketEpson(p, data)">
      Ticket
    </button>
  </div>
</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

    <!-- MODAL PAIEMENT -->
    <PaiementHospitalisationModal
      :visible="modalPaiementVisible"
      :hospitalisation="hospitalisationPourPaiement"
      :patientId="data?.patient?.id"
      @fermer="fermerPaiement"
      @payer="effectuerPaiement"
    />
  </div>
</div>
<div v-else class="text-center my-5">
  <div class="spinner-border text-primary" style="width:50px;height:50px"></div>
  <p class="mt-2">Chargement en cours...</p>
</div>
</template>

<script>
import api from "@/api";
import dayjs from "dayjs";
import PaiementHospitalisationModal from "@/components/PaiementHospitalisationModal.vue";

export default {
  components: { PaiementHospitalisationModal },

  data() {
    return {
      data: null,
      loading: true,
      showModal: false,
      dateSortieReelle: dayjs().format('YYYY-MM-DD'),
      hospitalisationPourPaiement: null,
      modalPaiementVisible: false,
      systeme: null,
    isLoadingSysteme: false,
    };
  },

  created() {
     this.loadSysteme();
    this.loadDetails();
    
  },
  computed: {
    montantReelCalcule() {

    if (!this.data) return { montant: 0, jours: 0 }

    const tarif = this.data.chambre?.type?.tarifParJour || 0

    const dateEntree = dayjs(this.data.dateEntree)

    // on utilise la date de sortie saisie dans le modal
    const dateSortie = dayjs(this.dateSortieReelle)

    const jours = dateSortie.diff(dateEntree, "day") + 1

    const montant = tarif * jours
  
    return {
      montant,
      jours
    }
  },

  cloturePossible() {

    if (!this.data?.dateSortieReelle) {
      return false
    }

    return this.data.totalPaye >= this.montantCloture.montant
  }

},

  methods: {
    formatDate(date) { return dayjs(date).format('DD-MM-YYYY'); },
    formatDateTime(date) { return dayjs(date).format('DD-MM-YYYY HH:mm'); },
    formatPrice(value) { return new Intl.NumberFormat().format(value); },

    async loadDetails() {
      try {
        const res = await api.getItem("hospitalisations", this.$route.params.id);
        this.data = res.data;
      } catch (e) { console.error(e); } 
      finally { this.loading = false; }
    },

    ouvrirPaiement(hosp) {
      this.hospitalisationPourPaiement = hosp;
      this.modalPaiementVisible = true;
    },
    fermerPaiement() {
      this.modalPaiementVisible = false;
      this.hospitalisationPourPaiement = null;
    },
    async effectuerPaiement(payload) {
      try {
        await api.createItem('paiement_hospitalisations', payload);
        this.fermerPaiement();
        await this.loadDetails();
        
      } catch (e) { alert("Erreur lors du paiement."); }
    },

    montantDeCalcul(p) {
      if (!p.assurance) return 0;
      return (p.montant) / (1 - (p.assurance.tauxCouverture /100));
    },
    partAssurance(p) {
      if (!p.assurance) return 0;
      const taux = p.assurance.tauxCouverture / 100;
      const montantTotal = p.montant / (1 - taux);
      return montantTotal - p.montant;
    },
    partPatient(p) { return p.montant; },

    async annulerCloture() {
      if (!confirm("Annuler la clôture ?")) return;
      try {
        await api.updateItem("hospitalisations", this.$route.params.id, {
          statut: "En cours",
          dateSortieReelle: null
        });
        await api.updateItem("lits", this.data.lit.id, { etat: "Occupé" });
        await this.loadDetails();
        alert("Clôture annulée.");
      } catch (e) { alert("Erreur."); }
    },
    async loadSysteme() {
  this.isLoadingSysteme = true;
  try {
    const res = await api.getItems('configurations');

    //  prendre le premier élément du tableau
    this.systeme = res.data?.data?.[0] || null;

  } catch (e) {
    console.error("Erreur chargement système", e);
  } finally {
    this.isLoadingSysteme = false;
  }
}
,

    /*async cloturerHospitalisation() {
      const sortie = dayjs(this.dateSortieReelle);
      if (this.data.totalPaye < this.data.montantCalcule.montant) {
        alert("Paiement insuffisant !");
        return;
      }
      try {
        await api.updateItem("hospitalisations", this.$route.params.id, {
          dateSortieReelle: sortie.toISOString(),
          statut: "Clôturée"
        });
        await api.updateItem("lits", this.data.lit.id, { etat: "libre" });
        this.showModal = false;
        this.$router.back();
      } catch (e) { alert("Erreur lors de la clôture."); }
    }*/
   async cloturerHospitalisation() {
  if (this.data.totalPaye < this.montantReelCalcule?.montant) {
    alert("Paiement insuffisant !");
    return;
  }
 //alert(this.dateSortieReelle);
  try {
    await api.custom(
      `hospitalisations/${this.$route.params.id}/cloturer`,
      "PATCH",
       {
         dateSortieReelle: this.dateSortieReelle
       }
    );

    this.showModal = false;
    await this.loadDetails(); 

  } catch (e) {
    alert("Erreur lors de la clôture.");
  }
}
,

async imprimerHospitalisationA4(hospitalisation) {
  if (!hospitalisation) return;

  const config = this.systeme || {};
  const user = this.$store.getters.user;

  const patient = hospitalisation.patient || {};
  const chambre = hospitalisation.chambre || {};
  const lit = hospitalisation.lit || {};
  const numHospi = hospitalisation.numHospitalisation

  const dateEntree = this.formatDate(hospitalisation.dateEntree);
  const dateSortiePrevue = this.formatDate(hospitalisation.dateSortiePrevue);
  const dateSortieReelle = hospitalisation.dateSortieReelle
    ? this.formatDate(hospitalisation.dateSortieReelle)
    : "En cours";

  const reference = `HOSP-${hospitalisation.id}-${new Date().getFullYear()}`;

  const baseURL = process.env.VUE_APP_API_BASE_URL || "http://127.0.0.1:8000";
  const logoUrl = config.logo
    ? (config.logo.startsWith("http")
        ? config.logo
        : `${baseURL}${config.logo}`)
    : "";

  const printWindow = window.open("", "_blank");

  const html = `
<!DOCTYPE html>
<html>
<head>
<title>Hospitalisation #${hospitalisation.id}</title>

<style>
@page { size: A4; margin: 2cm; }

body {
  font-family: "Times New Roman", serif;
  font-size: 14px;
  color: #000;
  margin: 0;
}

header {
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #0056b3;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

header img {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

.clinic-info h2 {
  margin: 0;
  color: #0056b3;
}

.clinic-info p {
  margin: 2px 0;
  font-size: 13px;
}

h3 {
  text-align: center;
  color: #0056b3;
  text-decoration: underline;
  margin: 20px 0;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}

th, td {
  border: 1px solid #0056b3;
  padding: 10px;
  font-size: 13px;
}

th {
  background-color: #e6f0ff;
}

.text-right {
  text-align: right;
}

.signature {
  margin-top: 50px;
  text-align: right;
}

footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #0056b3;
  padding-top: 5px;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}
</style>
</head>

<body>

<header>
  <div style="display:flex; gap:10px;">
    ${logoUrl ? `<img src="${logoUrl}" alt="Logo">` : ""}
    <div class="clinic-info">
      <h2>${config.nom || "CLINIQUE MÉDICALE"}</h2>
      <p>${config.adresse || ""}</p>
      <p>Tél : ${config.telephone || ""}</p>
      ${config.email ? `<p>Email : ${config.email}</p>` : ""}
    </div>
  </div>

  <div style="text-align:right;">
    <p><strong>Référence :</strong> ${numHospi}</p>
    <p><strong>Date entrée :</strong> ${dateEntree}</p>
    <p><strong>Statut :</strong> ${hospitalisation.statut}</p>
  </div>
</header>

<h3>FICHE D'HOSPITALISATION</h3>

<table>
<tr>
  <td><strong>Patient :</strong> ${patient.nom || ""} ${patient.prenom || ""}</td>
  <td><strong>Dossier :</strong> ${patient.numeroDossier || "—"}</td>
</tr>
<tr>
  <td><strong>Téléphone :</strong> ${patient.telephone || "—"}</td>
  <td><strong>Sortie prévue :</strong> ${dateSortiePrevue}</td>
</tr>
<tr>
  <td><strong>Sortie réelle :</strong> ${dateSortieReelle}</td>
  <td><strong>Chambre :</strong> ${chambre.numero || "—"} (Lit ${lit.numero || "—"})</td>
</tr>
</table>

<table>
<thead>
<tr>
  <th>Montant Calculé</th>
  <th>Total Payé</th>
  <th>Reste à Payer</th>
</tr>
</thead>
<tbody>
<tr>
  <td class="text-right">${hospitalisation.montantCalcule?.montant?.toLocaleString() || 0} FCFA</td>
  <td class="text-right">${hospitalisation.totalPaye?.toLocaleString() || 0} FCFA</td>
  <td class="text-right">${hospitalisation.resteAPayer?.toLocaleString() || 0} FCFA</td>
  ${hospitalisation.remboursement > 0 ? `
<tr>
  <td colspan="2"><strong>Remboursement si sortie en avance</strong></td>
  <td class="text-right text-success">
    ${hospitalisation.remboursement.toLocaleString()} FCFA 
  </td>
</tr>
` : ""}
</tr>
</tbody>
</table>

<div class="signature">
  <p><strong>L’Agent</strong></p>
  <p>${user.nom || ""} ${user.prenom || ""}</p>
  <br><br>
  <p>Signature & cachet</p>
</div>

<footer>
  <span>${config.nom || ""} - ${config.adresse || ""}</span>
  <span>© ${new Date().getFullYear()}</span>
</footer>

</body>
</html>
`;

  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
},
async imprimerHospitalisationTicketEpson(hospitalisation) {
  if (!hospitalisation) return;

  const config = this.systeme || {};
  const user = this.$store.getters.user || {};

  const patient = hospitalisation.patient || {};
  const chambre = hospitalisation.chambre || {};
  const lit = hospitalisation.lit || {};

  const baseURL = process.env.VUE_APP_API_BASE_URL || "http://127.0.0.1:8000";
  const logoUrl = config.logo
    ? (config.logo.startsWith("http")
        ? config.logo
        : `${baseURL}${config.logo}`)
    : "";

  const printWindow = window.open("", "_blank");

  const html = `
<!DOCTYPE html>
<html>
<head>
<title>Ticket Hospitalisation</title>

<style>
@page { size: 80mm auto; margin: 0; }

body {
  width: 80mm;
  font-family: monospace;
  font-size: 12px;
  padding: 6px;
}

.center { text-align: center; }
.bold { font-weight: bold; }
.right { text-align: right; }

.line {
  border-top: 1px dashed #000;
  margin: 6px 0;
}

img.logo {
  width: 50px;
  height: 50px;
  object-fit: contain;
}
</style>
</head>

<body>

<div class="center">
  ${logoUrl ? `<img src="${logoUrl}" class="logo">` : ""}
  <div class="bold">${config.nom || "CLINIQUE"}</div>
  <div>${config.telephone || ""}</div>
</div>

<div class="line"></div>

<div>HOSPITALISATION</div>
<div>N°: HOSP-${hospitalisation.id}</div>
<div>Patient: ${patient.nom || ""} ${patient.prenom || ""}</div>
<div>Chambre: ${chambre.numero || "—"} / Lit ${lit.numero || "—"}</div>

<div class="line"></div>

<div>Total: ${hospitalisation.montantCalcule?.montant?.toLocaleString() || 0} F</div>
<div>Payé: ${hospitalisation.totalPaye?.toLocaleString() || 0} F</div>
<div>Reste: ${hospitalisation.resteAPayer?.toLocaleString() || 0} F</div>
${hospitalisation.remboursement > 0 ? `
<div>Remb: ${hospitalisation.remboursement.toLocaleString()} F</div>
` : ""}

<div class="line"></div>

<div class="center">
Agent: ${user.nom || ""} ${user.prenom || ""}<br><br>
Merci pour votre confiance 🙏
</div>

</body>
</html>
`;

  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
},
async imprimerPaiementHospitalisationA4(paiement, hospitalisation) {
  if (!paiement || !hospitalisation) return;

  const config = this.systeme || {};
  const user = this.$store.getters.user;

  const patient = hospitalisation.patient || {};
  

  const datePaiement = this.formatDateTime(paiement.datePaiement);
  const reference = `PAY-HOSP-${paiement.id}-${new Date().getFullYear()}`;

  const baseURL = process.env.VUE_APP_API_BASE_URL || "http://127.0.0.1:8000";
  const logoUrl = config.logo
    ? (config.logo.startsWith("http")
        ? config.logo
        : `${baseURL}${config.logo}`)
    : "";

  const printWindow = window.open("", "_blank");

  const html = `
<!DOCTYPE html>
<html>
<head>
<title>Paiement #${paiement.id}</title>

<style>
@page { size: A4; margin: 2cm; }

body {
  font-family: "Times New Roman", serif;
  font-size: 14px;
  color: #000;
  margin: 0;
}

header {
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #198754;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

header img {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

.clinic-info h2 {
  margin: 0;
  color: #198754;
}

.clinic-info p {
  margin: 2px 0;
  font-size: 13px;
}

h3 {
  text-align: center;
  color: #198754;
  text-decoration: underline;
  margin: 20px 0;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}

th, td {
  border: 1px solid #198754;
  padding: 10px;
  font-size: 13px;
}

th {
  background-color: #e9f7ef;
}

.text-right {
  text-align: right;
}

.signature {
  margin-top: 50px;
  text-align: right;
}

footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #198754;
  padding-top: 5px;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}
</style>
</head>

<body>

<header>
  <div style="display:flex; gap:10px;">
    ${logoUrl ? `<img src="${logoUrl}" alt="Logo">` : ""}
    <div class="clinic-info">
      <h2>${config.nom || "CLINIQUE MÉDICALE"}</h2>
      <p>${config.adresse || ""}</p>
      <p>Tél : ${config.telephone || ""}</p>
      ${config.email ? `<p>Email : ${config.email}</p>` : ""}
    </div>
  </div>

  <div style="text-align:right;">
    <p><strong>Reçu N° :</strong> ${reference}</p>
    <p><strong>Date :</strong> ${datePaiement}</p>
  </div>
</header>

<h3>REÇU DE PAIEMENT - HOSPITALISATION</h3>

<table>
<tr>
  <td><strong>Patient :</strong> ${patient.nom || ""} ${patient.prenom || ""}</td>
  <td><strong>Dossier :</strong> ${patient.numeroDossier || "—"}</td>
</tr>
<tr>
  <td><strong>N° Hospitalisation :</strong> ${hospitalisation.numHospitalisation || "—"}</td>
  <td><strong>Type :</strong> ${paiement.type || "—"}</td>
</tr>
<tr>
  <td><strong>Mode de paiement :</strong> ${paiement.modePaiement?.nom || "—"}</td>
  <td><strong>Date paiement :</strong> ${datePaiement}</td>
</tr>
</table>

<table>
<thead>
<tr>
  <th>Montant de Base</th>
  <th>Part Assurance</th>
  <th>Part Patient</th>
  <th>Montant Payé</th>
</tr>
</thead>
<tbody>
<tr>
  <td class="text-right">${paiement.montantBase?.toLocaleString() || 0} FCFA</td>
  <td class="text-right">${paiement.partAssurance?.toLocaleString() || 0} FCFA</td>
  <td class="text-right">${paiement.partPatient?.toLocaleString() || 0} FCFA</td>
  <td class="text-right"><strong>${paiement.montant?.toLocaleString() || 0} FCFA</strong></td>
</tr>
</tbody>
</table>

<div class="signature">
  <p><strong>L’Agent</strong></p>
  <p>${user.nom || ""} ${user.prenom || ""}</p>
  <br><br>
  <p>Signature & cachet</p>
</div>

<footer>
  <span>${config.nom || ""} - ${config.adresse || ""}</span>
  <span>© ${new Date().getFullYear()}</span>
</footer>

</body>
</html>
`;

  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
},
async imprimerPaiementHospitalisationTicketEpson(paiement, hospitalisation) {
  if (!paiement || !hospitalisation) return;

  const config = this.systeme || {};
  const user = this.$store.getters.user || {};
  const patient = hospitalisation.patient || {};

  const datePaiement = this.formatDateTime(paiement.datePaiement);
  const reference = `PAY-HOSP-${paiement.id}-${new Date().getFullYear()}`;

  const baseURL = process.env.VUE_APP_API_BASE_URL || "http://127.0.0.1:8000";
  const logoUrl = config.logo
    ? (config.logo.startsWith("http")
        ? config.logo
        : `${baseURL}${config.logo}`)
    : "";

  const printWindow = window.open("", "_blank");

  const html = `
<!DOCTYPE html>
<html>
<head>
<title>Ticket Paiement</title>

<style>
@page { size: 80mm auto; margin: 0; }

body {
  width: 80mm;
  font-family: monospace;
  font-size: 12px;
  padding: 6px;
}

.center { text-align: center; }
.bold { font-weight: bold; }
.right { text-align: right; }

.line {
  border-top: 1px dashed #000;
  margin: 6px 0;
}

.row {
  display: flex;
  justify-content: space-between;
}

img.logo {
  width: 50px;
  height: 50px;
  object-fit: contain;
}
</style>
</head>

<body>

<div class="center">
  ${logoUrl ? `<img src="${logoUrl}" class="logo">` : ""}
  <div class="bold">${config.nom || "CLINIQUE"}</div>
  <div>${config.telephone || ""}</div>
  <div>${config.adresse || ""}</div>
</div>

<div class="line"></div>

<div class="center bold">REÇU PAIEMENT</div>
<div class="center">${reference}</div>
<div class="center">${datePaiement}</div>

<div class="line"></div>

<div><strong>Patient :</strong></div>
<div>${patient.nom || ""} ${patient.prenom || ""}</div>
<div>Dossier : ${patient.numeroDossier || "—"}</div>
<div>HOS : ${hospitalisation.numHospitalisation || "—"}</div>

<div class="line"></div>

<div class="row">
  <span>Mode :</span>
  <span>${paiement.modePaiement?.nom || "—"}</span>
</div>

<div class="row">
  <span>Type :</span>
  <span>${paiement.type || "—"}</span>
</div>

<div class="line"></div>

<div class="row">
  <span>Base :</span>
  <span>${paiement.montantBase?.toLocaleString() || 0}</span>
</div>

<div class="row">
  <span>Assurance :</span>
  <span>${paiement.partAssurance?.toLocaleString() || 0}</span>
</div>

<div class="row">
  <span>Patient :</span>
  <span>${paiement.partPatient?.toLocaleString() || 0}</span>
</div>

<div class="line"></div>

<div class="row bold">
  <span>TOTAL PAYÉ :</span>
  <span>${paiement.montant?.toLocaleString() || 0} FCFA</span>
</div>

<div class="line"></div>

<div class="center">
Agent : ${user.nom || ""} ${user.prenom || ""}<br><br>
Merci 🙏
</div>

</body>
</html>
`;

  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
},

    printPage() { window.print(); }
  }
};
</script>

<style scoped>
.section-title { font-weight: bold; color: #0d6efd; }

.modal-backdrop-custom {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.4);
  display: flex; align-items: center; justify-content: center; padding: 10px;
}
.modal-custom { background: white; width: 100%; max-width: 400px; padding: 20px; border-radius: 8px; }
.table-responsive { overflow-x: auto; }
</style>
